<template>
  <v-container class="d-flex justify-center">
    <v-card flat>
      <h4>ÅTKOMST NEKAD</h4>

      <div class="mt-5 mb-5 d-flex justify-center">
        <v-icon class="notAllowed ">$sl-stop</v-icon>
      </div>

      <p>
        <b>Sidan du försökte komma till kräver en annan behörighet än den du har eller så är du inte inloggad.</b>
      </p>
      <p>
        Kontrollera att du är inloggad och försök igen.
        <br><br>
        Om du tror att detta är ett fel och att du borde komma åt sidan rekommenderar vi att du 
        <a href="https://www.byggbranschensyrkesnamnd.se/kontakt/">kontaktar BYN</a>.
      </p>
      <p>Du kan gå tillbaka till startsidan genom att trycka på knappen nedan.</p>

      <v-btn color="primary" class="mt-6" @click="$router.push('/')">
        <v-icon>$sl-arrow-left</v-icon>Startsidan
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
// @group Common
// NotFound component
export default {
  name: 'Forbidden'
  /* components: {
    ActionButton
  } */
}
</script>

<style scoped>
.notAllowed {
  width: 192px;
  height: 192px;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>